
export const ThirdPartyContentEn = () => {
     
    return (
        <>
        <b>The MIT License (MIT)</b>
        <br />
        <br />
        Permission is hereby granted, free of charge, to any person obtaining a copy
        of this software and associated documentation files (the "Software"), to deal
        in the Software without restriction, including without limitation the rights
        to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        copies of the Software, and to permit persons to whom the Software is
        furnished to do so, subject to the following conditions:
        <br />
        <br />
        The above copyright notice and this permission notice shall be included in all
        copies or substantial portions of the Software.
        <br />
        <br />
        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
        SOFTWARE.
        <br />
        <br />
        <b>Apache 2.0</b>
        <br />
        <br />
        Apache License
        <br />
        Version 2.0, January 2004        
        <br />
        <br />
        TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION
        <br />
        <br />
        1. Definitions.
        <br />
        <br />
        "License" shall mean the terms and conditions for use, reproduction,
        <br />
        and distribution as defined by Sections 1 through 9 of this document.
        <br />
        <br />
        "Licensor" shall mean the copyright owner or entity authorized by
        <br />
        the copyright owner that is granting the License.
        <br />
        <br />
        "Legal Entity" shall mean the union of the acting entity and all
        <br />
        other entities that control, are controlled by, or are under common
        <br />
        control with that entity. For the purposes of this definition,
        <br />
        "control" means (i) the power, direct or indirect, to cause the
        <br />
        direction or management of such entity, whether by contract or
        <br />
        otherwise, or (ii) ownership of fifty percent (50%) or more of the
        <br />
        outstanding shares, or (iii) beneficial ownership of such entity.
        <br />
        <br />
        "You" (or "Your") shall mean an individual or Legal Entity
        <br />
        exercising permissions granted by this License.
        <br />
        <br />
        "Source" form shall mean the preferred form for making modifications,
        <br />
        including but not limited to software source code, documentation
        <br />
        source, and configuration files.
        <br />
        <br />
        "Object" form shall mean any form resulting from mechanical
        <br />
        transformation or translation of a Source form, including but
        <br />
        not limited to compiled object code, generated documentation,
        <br />
        and conversions to other media types.
        <br />
        <br />
        "Work" shall mean the work of authorship, whether in Source or
        <br />
        Object form, made available under the License, as indicated by a<br />
        copyright notice that is included in or attached to the work
        <br />
        (an example is provided in the Appendix below).
        <br />
        <br />
        "Derivative Works" shall mean any work, whether in Source or Object
        <br />
        form, that is based on (or derived from) the Work and for which the
        <br />
        editorial revisions, annotations, elaborations, or other modifications
        <br />
        represent, as a whole, an original work of authorship. For the purposes
        <br />
        of this License, Derivative Works shall not include works that remain
        <br />
        separable from, or merely link (or bind by name) to the interfaces of,
        <br />
        the Work and Derivative Works thereof.
        <br />
        <br />
        "Contribution" shall mean any work of authorship, including
        <br />
        the original version of the Work and any modifications or additions
        <br />
        to that Work or Derivative Works thereof, that is intentionally
        <br />
        submitted to Licensor for inclusion in the Work by the copyright owner
        <br />
        or by an individual or Legal Entity authorized to submit on behalf of
        <br />
        the copyright owner. For the purposes of this definition, "submitted"
        <br />
        means any form of electronic, verbal, or written communication sent
        <br />
        to the Licensor or its representatives, including but not limited to
        <br />
        communication on electronic mailing lists, source code control systems,
        <br />
        and issue tracking systems that are managed by, or on behalf of, the
        <br />
        Licensor for the purpose of discussing and improving the Work, but
        <br />
        excluding communication that is conspicuously marked or otherwise
        <br />
        designated in writing by the copyright owner as "Not a Contribution."
        <br />
        <br />
        "Contributor" shall mean Licensor and any individual or Legal Entity
        <br />
        on behalf of whom a Contribution has been received by Licensor and
        <br />
        subsequently incorporated within the Work.
        <br />
        <br />
        2. Grant of Copyright License. Subject to the terms and conditions of
        <br />
        this License, each Contributor hereby grants to You a perpetual,
        <br />
        worldwide, non-exclusive, no-charge, royalty-free, irrevocable
        <br />
        copyright license to reproduce, prepare Derivative Works of,
        <br />
        publicly display, publicly perform, sublicense, and distribute the
        <br />
        Work and such Derivative Works in Source or Object form.
        <br />
        <br />
        3. Grant of Patent License. Subject to the terms and conditions of
        <br />
        this License, each Contributor hereby grants to You a perpetual,
        <br />
        worldwide, non-exclusive, no-charge, royalty-free, irrevocable
        <br />
        (except as stated in this section) patent license to make, have made,
        <br />
        use, offer to sell, sell, import, and otherwise transfer the Work,
        <br />
        where such license applies only to those patent claims licensable
        <br />
        by such Contributor that are necessarily infringed by their
        <br />
        Contribution(s) alone or by combination of their Contribution(s)
        <br />
        with the Work to which such Contribution(s) was submitted. If You
        <br />
        institute patent litigation against any entity (including a<br />
        cross-claim or counterclaim in a lawsuit) alleging that the Work
        <br />
        or a Contribution incorporated within the Work constitutes direct
        <br />
        or contributory patent infringement, then any patent licenses
        <br />
        granted to You under this License for that Work shall terminate
        <br />
        as of the date such litigation is filed.
        <br />
        <br />
        4. Redistribution. You may reproduce and distribute copies of the
        <br />
        Work or Derivative Works thereof in any medium, with or without
        <br />
        modifications, and in Source or Object form, provided that You
        <br />
        meet the following conditions:
        <br />
        <br />
        (a) You must give any other recipients of the Work or
        <br />
        Derivative Works a copy of this License; and
        <br />
        <br />
        (b) You must cause any modified files to carry prominent notices
        <br />
        stating that You changed the files; and
        <br />
        <br />
        (c) You must retain, in the Source form of any Derivative Works
        <br />
        that You distribute, all copyright, patent, trademark, and
        <br />
        attribution notices from the Source form of the Work,
        <br />
        excluding those notices that do not pertain to any part of
        <br />
        the Derivative Works; and
        <br />
        <br />
        (d) If the Work includes a "NOTICE" text file as part of its
        <br />
        distribution, then any Derivative Works that You distribute must
        <br />
        include a readable copy of the attribution notices contained
        <br />
        within such NOTICE file, excluding those notices that do not
        <br />
        pertain to any part of the Derivative Works, in at least one
        <br />
        of the following places: within a NOTICE text file distributed
        <br />
        as part of the Derivative Works; within the Source form or
        <br />
        documentation, if provided along with the Derivative Works; or,
        <br />
        within a display generated by the Derivative Works, if and
        <br />
        wherever such third-party notices normally appear. The contents
        <br />
        of the NOTICE file are for informational purposes only and
        <br />
        do not modify the License. You may add Your own attribution
        <br />
        notices within Derivative Works that You distribute, alongside
        <br />
        or as an addendum to the NOTICE text from the Work, provided
        <br />
        that such additional attribution notices cannot be construed
        <br />
        as modifying the License.
        <br />
        <br />
        You may add Your own copyright statement to Your modifications and
        <br />
        may provide additional or different license terms and conditions
        <br />
        for use, reproduction, or distribution of Your modifications, or
        <br />
        for any such Derivative Works as a whole, provided Your use,
        <br />
        reproduction, and distribution of the Work otherwise complies with
        <br />
        the conditions stated in this License.
        <br />
        <br />
        5. Submission of Contributions. Unless You explicitly state otherwise,
        <br />
        any Contribution intentionally submitted for inclusion in the Work
        <br />
        by You to the Licensor shall be under the terms and conditions of
        <br />
        this License, without any additional terms or conditions.
        <br />
        Notwithstanding the above, nothing herein shall supersede or modify
        <br />
        the terms of any separate license agreement you may have executed
        <br />
        with Licensor regarding such Contributions.
        <br />
        <br />
        6. Trademarks. This License does not grant permission to use the trade
        <br />
        names, trademarks, service marks, or product names of the Licensor,
        <br />
        except as required for reasonable and customary use in describing the
        <br />
        origin of the Work and reproducing the content of the NOTICE file.
        <br />
        <br />
        7. Disclaimer of Warranty. Unless required by applicable law or
        <br />
        agreed to in writing, Licensor provides the Work (and each
        <br />
        Contributor provides its Contributions) on an "AS IS" BASIS,
        <br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        <br />
        implied, including, without limitation, any warranties or conditions
        <br />
        of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A<br />
        PARTICULAR PURPOSE. You are solely responsible for determining the
        <br />
        appropriateness of using or redistributing the Work and assume any
        <br />
        risks associated with Your exercise of permissions under this License.
        <br />
        <br />
        8. Limitation of Liability. In no event and under no legal theory,
        <br />
        whether in tort (including negligence), contract, or otherwise,
        <br />
        unless required by applicable law (such as deliberate and grossly
        <br />
        negligent acts) or agreed to in writing, shall any Contributor be
        <br />
        liable to You for damages, including any direct, indirect, special,
        <br />
        incidental, or consequential damages of any character arising as a<br />
        result of this License or out of the use or inability to use the
        <br />
        Work (including but not limited to damages for loss of goodwill,
        <br />
        work stoppage, computer failure or malfunction, or any and all
        <br />
        other commercial damages or losses), even if such Contributor
        <br />
        has been advised of the possibility of such damages.
        <br />
        <br />
        9. Accepting Warranty or Additional Liability. While redistributing
        <br />
        the Work or Derivative Works thereof, You may choose to offer,
        <br />
        and charge a fee for, acceptance of support, warranty, indemnity,
        <br />
        or other liability obligations and/or rights consistent with this
        <br />
        License. However, in accepting such obligations, You may act only
        <br />
        on Your own behalf and on Your sole responsibility, not on behalf
        <br />
        of any other Contributor, and only if You agree to indemnify,
        <br />
        defend, and hold each Contributor harmless for any liability
        <br />
        incurred by, or claims asserted against, such Contributor by reason
        <br />
        of your accepting any such warranty or additional liability.
        <br />
        <br />
        END OF TERMS AND CONDITIONS
        <br />
        <br />
        APPENDIX: How to apply the Apache License to your work.
        <br />
        <br />
        To apply the Apache License to your work, attach the following
        <br />
        boilerplate notice, with the fields enclosed by brackets "[]"
        <br />
        replaced with your own identifying information. (Don't include
        <br />
        the brackets!) The text should be enclosed in the appropriate
        <br />
        comment syntax for the file format. We also recommend that a<br />
        file or class name and description of purpose be included on the
        <br />
        same "printed page" as the copyright notice for easier
        <br />
        identification within third-party archives.
        <br />
        <br />
        Copyright [yyyy] [name of copyright owner]
        <br />
        <br />
        Licensed under the Apache License, Version 2.0 (the "License");
        <br />
        you may not use this file except in compliance with the License.
        <br />
        You may obtain a copy of the License at
        <br />
        <br />
        <a
            target="_blank"
            href="http://www.apache.org/licenses/LICENSE-2.0"
            rel="noreferrer noopener"
        >
            http://www.apache.org/licenses/LICENSE-2.0
        </a>
        <br />
        <br />
        Unless required by applicable law or agreed to in writing, software
        <br />
        distributed under the License is distributed on an "AS IS" BASIS,
        <br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
        <br />
        See the License for the specific language governing permissions and
        <br />
        limitations under the License.
        <br />
        <br />
        <br />
        <b>Ms-PL Microsoft Public License (Ms-PL)</b>
        <br />
        <br />
        This license governs use of the accompanying software. If you use the
        software, you accept this license. If you do not accept the license, do not
        use the software.
        <br />
        <br />
        Definitions
        <br />
        The terms "reproduce," "reproduction," "derivative works," and "distribution"
        have the same meaning here as under U.S. copyright law.
        <br />
        <br />A "contribution" is the original software, or any additions or changes
        to the software.
        <br />
        <br />A "contributor" is any person that distributes its contribution under
        this license.
        <br />
        <br />
        "Licensed patents" are a contributor's patent claims that read directly on its
        contribution.
        <br />
        <br />
        Grant of Rights
        <br />
        (A) Copyright Grant- Subject to the terms of this license, including the
        license conditions and limitations in section 3, each contributor grants you a
        non-exclusive, worldwide, royalty-free copyright license to reproduce its
        contribution, prepare derivative works of its contribution, and distribute its
        contribution or any derivative works that you create.
        <br />
        <br />
        (B) Patent Grant- Subject to the terms of this license, including the license
        conditions and limitations in section 3, each contributor grants you a
        non-exclusive, worldwide, royalty-free license under its licensed patents to
        make, have made, use, sell, offer for sale, import, and/or otherwise dispose
        of its contribution in the software or derivative works of the contribution in
        the software.
        <br />
        <br />
        Conditions and Limitations
        <br />
        (A) No Trademark License- This license does not grant you rights to use any
        contributors' name, logo, or trademarks.
        <br />
        <br />
        (B) If you bring a patent claim against any contributor over patents that you
        claim are infringed by the software, your patent license from such contributor
        to the software ends automatically.
        <br />
        <br />
        (C) If you distribute any portion of the software, you must retain all
        copyright, patent, trademark, and attribution notices that are present in the
        software.
        <br />
        <br />
        (D) If you distribute any portion of the software in source code form, you may
        do so only under this license by including a complete copy of this license
        with your distribution. If you distribute any portion of the software in
        compiled or object code form, you may only do so under a license that complies
        with this license.
        <br />
        <br />
        (E) The software is licensed "as-is." You bear the risk of using it. The
        contributors give no express warranties, guarantees or conditions. You may
        have additional consumer rights under your local laws which this license
        cannot change. To the extent permitted under your local laws, the contributors
        exclude the implied warranties of merchantability, fitness for a particular
        purpose and non-infringement.
        <br />
        <br />
        <br />
        <b>ISC License (ISC)</b>
        <br />
        Copyright
        <br />
        <br />
        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted, provided that the above
        copyright notice and this permission notice appear in all copies.
        <br />
        <br />
        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        <br />
        License notice for Microsoft.AspNetCore.SpaProxy (v6.0.9)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/aspnetcore at
        3fe12b935c03138f76364dc877a7e069e254b5b2
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for FluentValidation.AspNetCore (v11.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/FluentValidation/FluentValidation.AspNetCore at
        7f3ad0d29f9509637b643de31de57181edfd3e76
        <br />
        <br />
        https://fluentvalidation.net/
        <br />
        <br />
        Copyright (c) Jeremy Skinner, .NET Foundation, and contributors 2008-2022
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for MessagePack.AspNetCoreMvcFormatter (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.AspNetCore (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for AutoMapper (v10.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/AutoMapper/AutoMapper at
        f31e398a596438a939bf19d5bb97ed218124731d
        <br />
        <br />
        https://automapper.org/
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for CommonInterfaces (v2.6.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        <br />
        License notice for Crc32.NET (v1.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/force-net/Crc32.NET
        <br />
        <br />
        Copyright by Force 2016-2017
        <br />
        <br />
        License available at
        https://github.com/force-net/Crc32.NET/blob/develop/LICENSE
        <br />
        <br />
        <br />
        License notice for CsvHelper (v30.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JoshClose/CsvHelper at
        04834b58ddbe89b44c9f33250d0d305fbfa661c1
        <br />
        <br />
        https://joshclose.github.io/CsvHelper/
        <br />
        <br />
        Copyright © 2009-2022 Josh Close
        <br />
        <br />
        Licensed under MS-PL OR Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/MS-PL%20OR%20Apache-2.0
        <br />
        <br />
        <br />
        License notice for EntityFramework (v6.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/EntityFramework6 at
        28150414eaebf04cbd213de11f9f77a9d5ae35ff
        <br />
        <br />
        http://go.microsoft.com/fwlink/?LinkID=263480
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for FluentValidation (v11.2.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JeremySkinner/fluentvalidation at
        b9c944258a5ad26cb1e486fd7749b6ebe62e6ed1
        <br />
        <br />
        https://fluentvalidation.net/
        <br />
        <br />
        Copyright (c) Jeremy Skinner, .NET Foundation, and contributors 2008-2022
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for FluentValidation.DependencyInjectionExtensions (v11.2.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JeremySkinner/fluentvalidation at
        b9c944258a5ad26cb1e486fd7749b6ebe62e6ed1
        <br />
        <br />
        https://fluentvalidation.net/
        <br />
        <br />
        Copyright (c) Jeremy Skinner, .NET Foundation, and contributors 2008-2022
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Jace (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/pieterderycke/Jace
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for LinqKit (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/scottksmith95/LINQKit
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for LinqKit.Core (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/scottksmith95/LINQKit
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for MessagePack (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for MessagePack.Annotations (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.DependencyCollector (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.EventCounterCollector
        (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.PerfCounterCollector
        (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.WindowsServer (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for
        Microsoft.ApplicationInsights.WindowsServer.TelemetryChannel (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Antiforgery (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Antiforgery at
        9e5146cff912ebbd003d597eb055144e740759fa
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authentication.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authentication.Core (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authorization (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Security at 93926543f8469614c2feb23de8a8c0561b8b2463
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authorization.Policy (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Security at 93926543f8469614c2feb23de8a8c0561b8b2463
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Cryptography.Internal (v5.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/aspnetcore at
        371a26f07b23ad77c636332c2dfc0cbd1d8137ba
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Cryptography.KeyDerivation (v5.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/aspnetcore at
        371a26f07b23ad77c636332c2dfc0cbd1d8137ba
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.DataProtection (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        ce8cf65589734f82b0536c543aba5bd60d0a5a98
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.DataProtection.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        ce8cf65589734f82b0536c543aba5bd60d0a5a98
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Diagnostics.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Diagnostics at
        c802d5ef5fba1ba8dfbcb8c3741af2ba15e9d1aa
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 1596c2ba5508fceefd929228b4e5e95e50b1d4d4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting.Server.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Html.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HtmlAbstractions at
        6c5ca90d81f9013a8652da4c1752bd0b4d18e908
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http (v2.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        522705f9a27b99ca4ad261f2e89fe51a77b2338e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Extensions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Features (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.JsonPatch (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/JsonPatch at
        3b485909ebec98d9437058dbcf45dac3ccd1f157
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Core (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.DataAnnotations (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Formatters.Json (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.ViewFeatures (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.ResponseCaching.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/ResponseCaching at
        9f49398f28d7c1e0dc0305f8080351c413b0f297
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Routing (v2.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        522705f9a27b99ca4ad261f2e89fe51a77b2338e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Routing.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Routing at 3d828221a19d91907c52c2f40928b019bee1ef92
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.WebUtilities (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.CSharp (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Memory (v6.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 839cdfb0ecca5e0be3dbccd926e7651ef50fdf10
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Binder (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.EnvironmentVariables
        (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.FileExtensions (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Json (v2.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        b1d43cf8b49433054e33f4b6ab66cdffb6fa645e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyInjection (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyInjection.Abstractions
        (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyModel (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DiagnosticAdapter (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        http://www.asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation
        <br />
        <br />
        License available at
        http://www.microsoft.com/web/webpi/eula/net_library_eula_enu.htm
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileProviders.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileProviders.Physical (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/FileSystem at
        7923b2c69fbf51e160f46d48f80f14e6742e0ab4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileSystemGlobbing (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/FileSystem at
        7923b2c69fbf51e160f46d48f80f14e6742e0ab4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Hosting.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Localization (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Localization at
        de1579bdda645ba8631403af8720929b76939853
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Localization.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Localization at
        de1579bdda645ba8631403af8720929b76939853
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Logging at a0398f0baf9ecc8e5fb6afc3a9b89f0d49cf041e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging.ApplicationInsights (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.ObjectPool (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Options (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.PlatformAbstractions (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        http://www.asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation
        <br />
        <br />
        License available at
        http://www.microsoft.com/web/webpi/eula/net_library_eula_enu.htm
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Primitives (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.WebEncoders (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HtmlAbstractions at
        6c5ca90d81f9013a8652da4c1752bd0b4d18e908
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Net.Http.Headers (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.NET.StringTools (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/msbuild at 4242f381a90f77f483b123819759db1ff8eddf67
        <br />
        <br />
        http://go.microsoft.com/fwlink/?LinkId=624683
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Platforms (v3.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Targets (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Microsoft.OpenApi (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/OpenAPI.NET
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/Microsoft/OpenAPI.NET/master/LICENSE
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.Registry (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.SystemEvents (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for NETStandard.Library (v2.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        .NET Foundation and Contributors
        <br />
        <br />
        License available at
        https://github.com/dotnet/standard/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for Newtonsoft.Json (v13.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JamesNK/Newtonsoft.Json at
        ae9fe44e1323e91bcbd185ca1a14099fba7c021f
        <br />
        <br />
        https://www.newtonsoft.com/json
        <br />
        <br />
        Copyright © James Newton-King 2008
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Newtonsoft.Json.Bson (v1.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JamesNK/Newtonsoft.Json.Bson
        <br />
        <br />
        http://www.newtonsoft.com/json
        <br />
        <br />
        Copyright © James Newton-King 2017
        <br />
        <br />
        License available at
        https://raw.github.com/JamesNK/Newtonsoft.Json.Bson/master/LICENSE.md
        <br />
        <br />
        <br />
        License notice for NReco.Csv (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/nreco/csv
        <br />
        <br />
        Copyright (c) 2017-2018 Vitalii Fedorchenko
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/nreco/csv/master/LICENSE
        <br />
        <br />
        <br />
        License notice for
        runtime.debian.8-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.23-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.24-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Data.SqlClient.sni (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Net.Http (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.Apple (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.13.2-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.42.1-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.Apple
        (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.rhel.7-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.14.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-arm64.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-x64.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-x86.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for SharpZipLib (v1.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/icsharpcode/SharpZipLib at
        cea8b0dc154c71040ff74d731ff55c451e8dc59d
        <br />
        <br />
        Copyright © 2000-2022 SharpZipLib Contributors
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore.Swagger (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git at
        c70947f4ccc80bca528ff1573c0f2462f3e7db8f
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore.SwaggerGen (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git at
        c70947f4ccc80bca528ff1573c0f2462f3e7db8f
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore.SwaggerUI (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git at
        c70947f4ccc80bca528ff1573c0f2462f3e7db8f
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Buffers (v4.5.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.CodeDom (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Collections (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Collections.Concurrent (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ComponentModel (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ComponentModel.Annotations (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Configuration.ConfigurationManager (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Data.SqlClient (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Debug (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.DiagnosticSource (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.PerformanceCounter (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.StackTrace (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Tools (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Tracing (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Drawing.Common (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Globalization (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Calendars (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem.AccessControl (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Linq (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Memory (v4.5.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Net.Http (v4.3.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.NameResolution (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Private.DataContractSerialization (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit.ILGeneration (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit.Lightweight (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Metadata (v1.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Reflection.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.TypeExtensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Resources.ResourceManager (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.CompilerServices.Unsafe (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Runtime.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Handles (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.InteropServices (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Numerics (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Serialization.Json (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Serialization.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.AccessControl (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Algorithms (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Cng (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Csp (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.OpenSsl (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Pkcs (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.ProtectedData (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.X509Certificates (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Xml (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Permissions (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Principal.Windows (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding.CodePages (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Text.Encodings.Web (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Json (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.RegularExpressions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Tasks (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Tasks.Extensions (v4.5.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Threading.Thread (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Windows.Extensions (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Xml.ReaderWriter (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XDocument (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XmlDocument (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XmlSerializer (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Unity (v5.11.10)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/unitycontainer/unity
        <br />
        <br />
        Copyright © .NET Foundation and Contributors. All Rights Reserved
        <br />
        <br />
        License available at https://github.com/unitycontainer/unity/blob/v5.x/LICENSE
        <br />
        <br />
        License notice for CsvHelper (v30.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JoshClose/CsvHelper at
        04834b58ddbe89b44c9f33250d0d305fbfa661c1
        <br />
        <br />
        https://joshclose.github.io/CsvHelper/
        <br />
        <br />
        Copyright © 2009-2022 Josh Close
        <br />
        <br />
        Licensed under MS-PL OR Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/MS-PL%20OR%20Apache-2.0
        <br />
        <br />
        <br />
        License notice for Jace (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/pieterderycke/Jace
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for LinqKit (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/scottksmith95/LINQKit
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for CommonInterfaces (v2.6.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        <br />
        License notice for Crc32.NET (v1.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/force-net/Crc32.NET
        <br />
        <br />
        Copyright by Force 2016-2017
        <br />
        <br />
        License available at
        https://github.com/force-net/Crc32.NET/blob/develop/LICENSE
        <br />
        <br />
        <br />
        License notice for EntityFramework (v6.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/EntityFramework6 at
        28150414eaebf04cbd213de11f9f77a9d5ae35ff
        <br />
        <br />
        http://go.microsoft.com/fwlink/?LinkID=263480
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for LinqKit.Core (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/scottksmith95/LINQKit
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.CSharp (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Memory (v6.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 839cdfb0ecca5e0be3dbccd926e7651ef50fdf10
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyInjection.Abstractions
        (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyModel (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Options (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Primitives (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Platforms (v3.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Targets (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.Registry (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.SystemEvents (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for NETStandard.Library (v2.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        .NET Foundation and Contributors
        <br />
        <br />
        License available at
        https://github.com/dotnet/standard/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for Newtonsoft.Json (v13.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JamesNK/Newtonsoft.Json at
        ae9fe44e1323e91bcbd185ca1a14099fba7c021f
        <br />
        <br />
        https://www.newtonsoft.com/json
        <br />
        <br />
        Copyright © James Newton-King 2008
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for NReco.Csv (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/nreco/csv
        <br />
        <br />
        Copyright (c) 2017-2018 Vitalii Fedorchenko
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/nreco/csv/master/LICENSE
        <br />
        <br />
        <br />
        License notice for
        runtime.debian.8-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.23-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.24-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Data.SqlClient.sni (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Net.Http (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.Apple (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.13.2-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.42.1-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.Apple
        (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.rhel.7-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.14.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-arm64.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-x64.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-x86.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for SharpZipLib (v1.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/icsharpcode/SharpZipLib at
        cea8b0dc154c71040ff74d731ff55c451e8dc59d
        <br />
        <br />
        Copyright © 2000-2022 SharpZipLib Contributors
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Buffers (v4.5.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.CodeDom (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Collections (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Collections.Concurrent (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ComponentModel.Annotations (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Configuration.ConfigurationManager (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Data.SqlClient (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Debug (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.DiagnosticSource (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Tracing (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Drawing.Common (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Globalization (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Calendars (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Linq (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Memory (v4.5.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Net.Http (v4.3.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Resources.ResourceManager (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.CompilerServices.Unsafe (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Runtime.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Handles (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.InteropServices (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Numerics (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.AccessControl (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Algorithms (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Cng (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Csp (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.OpenSsl (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.ProtectedData (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.X509Certificates (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Permissions (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Principal.Windows (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding.CodePages (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Encodings.Web (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Json (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Threading (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Tasks (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Windows.Extensions (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for Unity (v5.11.10)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/unitycontainer/unity
        <br />
        <br />
        Copyright © .NET Foundation and Contributors. All Rights Reserved
        <br />
        <br />
        License available at https://github.com/unitycontainer/unity/blob/v5.x/LICENSE
        <br />
        <br />
        <br />
        License notice for FluentValidation.AspNetCore (v11.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/FluentValidation/FluentValidation.AspNetCore at
        7f3ad0d29f9509637b643de31de57181edfd3e76
        <br />
        <br />
        https://fluentvalidation.net/
        <br />
        <br />
        Copyright (c) Jeremy Skinner, .NET Foundation, and contributors 2008-2022
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for MessagePack.AspNetCoreMvcFormatter (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.AspNetCore (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for AutoMapper (v10.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/AutoMapper/AutoMapper at
        f31e398a596438a939bf19d5bb97ed218124731d
        <br />
        <br />
        https://automapper.org/
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for CommonInterfaces (v2.6.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        <br />
        License notice for Crc32.NET (v1.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/force-net/Crc32.NET
        <br />
        <br />
        Copyright by Force 2016-2017
        <br />
        <br />
        License available at
        https://github.com/force-net/Crc32.NET/blob/develop/LICENSE
        <br />
        <br />
        <br />
        License notice for CsvHelper (v30.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JoshClose/CsvHelper at
        04834b58ddbe89b44c9f33250d0d305fbfa661c1
        <br />
        <br />
        https://joshclose.github.io/CsvHelper/
        <br />
        <br />
        Copyright © 2009-2022 Josh Close
        <br />
        <br />
        Licensed under MS-PL OR Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/MS-PL%20OR%20Apache-2.0
        <br />
        <br />
        <br />
        License notice for EntityFramework (v6.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/EntityFramework6 at
        28150414eaebf04cbd213de11f9f77a9d5ae35ff
        <br />
        <br />
        http://go.microsoft.com/fwlink/?LinkID=263480
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for FluentValidation (v11.2.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JeremySkinner/fluentvalidation at
        b9c944258a5ad26cb1e486fd7749b6ebe62e6ed1
        <br />
        <br />
        https://fluentvalidation.net/
        <br />
        <br />
        Copyright (c) Jeremy Skinner, .NET Foundation, and contributors 2008-2022
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for FluentValidation.DependencyInjectionExtensions (v11.2.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JeremySkinner/fluentvalidation at
        b9c944258a5ad26cb1e486fd7749b6ebe62e6ed1
        <br />
        <br />
        https://fluentvalidation.net/
        <br />
        <br />
        Copyright (c) Jeremy Skinner, .NET Foundation, and contributors 2008-2022
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Jace (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/pieterderycke/Jace
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for LinqKit (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/scottksmith95/LINQKit
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for LinqKit.Core (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/scottksmith95/LINQKit
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for MessagePack (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for MessagePack.Annotations (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.DependencyCollector (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.EventCounterCollector
        (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.PerfCounterCollector
        (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.WindowsServer (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for
        Microsoft.ApplicationInsights.WindowsServer.TelemetryChannel (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Antiforgery (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Antiforgery at
        9e5146cff912ebbd003d597eb055144e740759fa
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authentication.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authentication.Core (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authorization (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Security at 93926543f8469614c2feb23de8a8c0561b8b2463
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authorization.Policy (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Security at 93926543f8469614c2feb23de8a8c0561b8b2463
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Cryptography.Internal (v5.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/aspnetcore at
        371a26f07b23ad77c636332c2dfc0cbd1d8137ba
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Cryptography.KeyDerivation (v5.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/aspnetcore at
        371a26f07b23ad77c636332c2dfc0cbd1d8137ba
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.DataProtection (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        ce8cf65589734f82b0536c543aba5bd60d0a5a98
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.DataProtection.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        ce8cf65589734f82b0536c543aba5bd60d0a5a98
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Diagnostics.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Diagnostics at
        c802d5ef5fba1ba8dfbcb8c3741af2ba15e9d1aa
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 1596c2ba5508fceefd929228b4e5e95e50b1d4d4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting.Server.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Html.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HtmlAbstractions at
        6c5ca90d81f9013a8652da4c1752bd0b4d18e908
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http (v2.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        522705f9a27b99ca4ad261f2e89fe51a77b2338e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Extensions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Features (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.JsonPatch (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/JsonPatch at
        3b485909ebec98d9437058dbcf45dac3ccd1f157
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Core (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.DataAnnotations (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Formatters.Json (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.ViewFeatures (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.ResponseCaching.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/ResponseCaching at
        9f49398f28d7c1e0dc0305f8080351c413b0f297
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Routing (v2.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        522705f9a27b99ca4ad261f2e89fe51a77b2338e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Routing.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Routing at 3d828221a19d91907c52c2f40928b019bee1ef92
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.WebUtilities (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.CSharp (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Memory (v6.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 839cdfb0ecca5e0be3dbccd926e7651ef50fdf10
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Binder (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.EnvironmentVariables
        (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.FileExtensions (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Json (v2.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        b1d43cf8b49433054e33f4b6ab66cdffb6fa645e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyInjection (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyInjection.Abstractions
        (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyModel (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DiagnosticAdapter (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        http://www.asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation
        <br />
        <br />
        License available at
        http://www.microsoft.com/web/webpi/eula/net_library_eula_enu.htm
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileProviders.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileProviders.Physical (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/FileSystem at
        7923b2c69fbf51e160f46d48f80f14e6742e0ab4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileSystemGlobbing (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/FileSystem at
        7923b2c69fbf51e160f46d48f80f14e6742e0ab4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Hosting.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Localization (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Localization at
        de1579bdda645ba8631403af8720929b76939853
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Localization.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Localization at
        de1579bdda645ba8631403af8720929b76939853
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Logging at a0398f0baf9ecc8e5fb6afc3a9b89f0d49cf041e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging.ApplicationInsights (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.ObjectPool (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Options (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.PlatformAbstractions (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        http://www.asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation
        <br />
        <br />
        License available at
        http://www.microsoft.com/web/webpi/eula/net_library_eula_enu.htm
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Primitives (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.WebEncoders (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HtmlAbstractions at
        6c5ca90d81f9013a8652da4c1752bd0b4d18e908
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Net.Http.Headers (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.NET.StringTools (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/msbuild at 4242f381a90f77f483b123819759db1ff8eddf67
        <br />
        <br />
        http://go.microsoft.com/fwlink/?LinkId=624683
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Platforms (v3.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Targets (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Microsoft.OpenApi (v1.2.3)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/OpenAPI.NET
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/Microsoft/OpenAPI.NET/master/LICENSE
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.Registry (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.SystemEvents (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for NETStandard.Library (v2.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        .NET Foundation and Contributors
        <br />
        <br />
        License available at
        https://github.com/dotnet/standard/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for Newtonsoft.Json (v13.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JamesNK/Newtonsoft.Json at
        ae9fe44e1323e91bcbd185ca1a14099fba7c021f
        <br />
        <br />
        https://www.newtonsoft.com/json
        <br />
        <br />
        Copyright © James Newton-King 2008
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Newtonsoft.Json.Bson (v1.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JamesNK/Newtonsoft.Json.Bson
        <br />
        <br />
        http://www.newtonsoft.com/json
        <br />
        <br />
        Copyright © James Newton-King 2017
        <br />
        <br />
        License available at
        https://raw.github.com/JamesNK/Newtonsoft.Json.Bson/master/LICENSE.md
        <br />
        <br />
        <br />
        License notice for NReco.Csv (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/nreco/csv
        <br />
        <br />
        Copyright (c) 2017-2018 Vitalii Fedorchenko
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/nreco/csv/master/LICENSE
        <br />
        <br />
        <br />
        License notice for
        runtime.debian.8-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.23-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.24-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Data.SqlClient.sni (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Net.Http (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.Apple (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.13.2-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.42.1-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.Apple
        (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.rhel.7-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.14.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-arm64.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-x64.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.win-x86.runtime.native.System.Data.SqlClient.sni
        (v4.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for SharpZipLib (v1.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/icsharpcode/SharpZipLib at
        cea8b0dc154c71040ff74d731ff55c451e8dc59d
        <br />
        <br />
        Copyright © 2000-2022 SharpZipLib Contributors
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore.Swagger (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git at
        c70947f4ccc80bca528ff1573c0f2462f3e7db8f
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore.SwaggerGen (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git at
        c70947f4ccc80bca528ff1573c0f2462f3e7db8f
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Swashbuckle.AspNetCore.SwaggerUI (v6.4.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore.git at
        c70947f4ccc80bca528ff1573c0f2462f3e7db8f
        <br />
        <br />
        https://github.com/domaindrivendev/Swashbuckle.AspNetCore
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Buffers (v4.5.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.CodeDom (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Collections (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Collections.Concurrent (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ComponentModel (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ComponentModel.Annotations (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Configuration.ConfigurationManager (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Data.SqlClient (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Debug (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.DiagnosticSource (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.PerformanceCounter (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.StackTrace (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Tools (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Tracing (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Drawing.Common (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Globalization (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Calendars (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem.AccessControl (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Linq (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Memory (v4.5.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Net.Http (v4.3.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.NameResolution (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Private.DataContractSerialization (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit.ILGeneration (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit.Lightweight (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Metadata (v1.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Reflection.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.TypeExtensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Resources.ResourceManager (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.CompilerServices.Unsafe (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Runtime.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Handles (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.InteropServices (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Numerics (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Serialization.Json (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Serialization.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.AccessControl (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Algorithms (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Cng (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Csp (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.OpenSsl (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Pkcs (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.ProtectedData (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.X509Certificates (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Xml (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Permissions (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Principal.Windows (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding.CodePages (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Text.Encodings.Web (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Json (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.RegularExpressions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Tasks (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Tasks.Extensions (v4.5.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Threading.Thread (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Windows.Extensions (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Xml.ReaderWriter (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XDocument (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XmlDocument (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XmlSerializer (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Unity (v5.11.10)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/unitycontainer/unity
        <br />
        <br />
        Copyright © .NET Foundation and Contributors. All Rights Reserved
        <br />
        <br />
        License available at https://github.com/unitycontainer/unity/blob/v5.x/LICENSE
        <br />
        <br />
        <br />
        License notice for Dapper (v2.0.123)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/DapperLib/Dapper at
        2a837ad7d036671ac9a75c9945bb970aa41b7de9
        <br />
        <br />
        2019 Stack Exchange, Inc.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for dbup-sqlite (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dbup.github.io/
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for MessagePack.AspNetCoreMvcFormatter (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.AspNetCore (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Data.Sqlite (v7.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/efcore at 865c6a897058a6ee4c7e014c0cefdcb04dc5e292
        <br />
        <br />
        https://docs.microsoft.com/dotnet/standard/data/sqlite/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for AutoMapper (v10.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/AutoMapper/AutoMapper at
        f31e398a596438a939bf19d5bb97ed218124731d
        <br />
        <br />
        https://automapper.org/
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for dbup-core (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dbup.github.io/
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for MessagePack (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for MessagePack.Annotations (v2.4.35)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/neuecc/MessagePack-CSharp at
        eab5122e95f32443c686548e646523038ceb7543
        <br />
        <br />
        Copyright © Yoshifumi Kawai and contributors. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.DependencyCollector (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.EventCounterCollector
        (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.PerfCounterCollector
        (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.ApplicationInsights.WindowsServer (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for
        Microsoft.ApplicationInsights.WindowsServer.TelemetryChannel (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Antiforgery (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Antiforgery at
        9e5146cff912ebbd003d597eb055144e740759fa
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authentication.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authentication.Core (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authorization (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Security at 93926543f8469614c2feb23de8a8c0561b8b2463
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Authorization.Policy (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Security at 93926543f8469614c2feb23de8a8c0561b8b2463
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Cryptography.Internal (v5.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/aspnetcore at
        371a26f07b23ad77c636332c2dfc0cbd1d8137ba
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Cryptography.KeyDerivation (v5.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/aspnetcore at
        371a26f07b23ad77c636332c2dfc0cbd1d8137ba
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.DataProtection (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        ce8cf65589734f82b0536c543aba5bd60d0a5a98
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.DataProtection.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        ce8cf65589734f82b0536c543aba5bd60d0a5a98
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Diagnostics.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Diagnostics at
        c802d5ef5fba1ba8dfbcb8c3741af2ba15e9d1aa
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 1596c2ba5508fceefd929228b4e5e95e50b1d4d4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Hosting.Server.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Html.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HtmlAbstractions at
        6c5ca90d81f9013a8652da4c1752bd0b4d18e908
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http (v2.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        522705f9a27b99ca4ad261f2e89fe51a77b2338e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Extensions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Http.Features (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.JsonPatch (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/JsonPatch at
        3b485909ebec98d9437058dbcf45dac3ccd1f157
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Core (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.DataAnnotations (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.Formatters.Json (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Mvc.ViewFeatures (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Mvc at a6199bbfbab05583f987bae322fb04566841aaea
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.ResponseCaching.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/ResponseCaching at
        9f49398f28d7c1e0dc0305f8080351c413b0f297
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Routing (v2.2.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/AspNetCore at
        522705f9a27b99ca4ad261f2e89fe51a77b2338e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.Routing.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Routing at 3d828221a19d91907c52c2f40928b019bee1ef92
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.AspNetCore.WebUtilities (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.CSharp (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Data.Sqlite.Core (v7.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/efcore at 865c6a897058a6ee4c7e014c0cefdcb04dc5e292
        <br />
        <br />
        https://docs.microsoft.com/dotnet/standard/data/sqlite/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Caching.Memory (v6.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 839cdfb0ecca5e0be3dbccd926e7651ef50fdf10
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Binder (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.EnvironmentVariables
        (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.FileExtensions (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        2679cfd94694a29230726708717ab9c4579a5d80
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Configuration.Json (v2.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Configuration at
        b1d43cf8b49433054e33f4b6ab66cdffb6fa645e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyInjection (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyInjection.Abstractions
        (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DependencyModel (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.DiagnosticAdapter (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        http://www.asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation
        <br />
        <br />
        License available at
        http://www.microsoft.com/web/webpi/eula/net_library_eula_enu.htm
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileProviders.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileProviders.Physical (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/FileSystem at
        7923b2c69fbf51e160f46d48f80f14e6742e0ab4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.FileSystemGlobbing (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/FileSystem at
        7923b2c69fbf51e160f46d48f80f14e6742e0ab4
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Hosting.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Hosting at 0724e6cde1149ee1a19bfec9c13a2c9327b71213
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Localization (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Localization at
        de1579bdda645ba8631403af8720929b76939853
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Localization.Abstractions (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Localization at
        de1579bdda645ba8631403af8720929b76939853
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging (v2.1.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Logging at a0398f0baf9ecc8e5fb6afc3a9b89f0d49cf041e
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/Home/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging.Abstractions (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Logging.ApplicationInsights (v2.15.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/Microsoft/ApplicationInsights-dotnet at
        2c60e729d6512c31e5791ec93c9f7796d54fe426
        <br />
        <br />
        https://go.microsoft.com/fwlink/?LinkId=392727
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.ObjectPool (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/Extensions at
        9bc79b2f25a3724376d7af19617c33749a30ea3a
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Options (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.PlatformAbstractions (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        http://www.asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation
        <br />
        <br />
        License available at
        http://www.microsoft.com/web/webpi/eula/net_library_eula_enu.htm
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.Primitives (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Extensions.WebEncoders (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HtmlAbstractions at
        6c5ca90d81f9013a8652da4c1752bd0b4d18e908
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.Net.Http.Headers (v2.2.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/aspnet/HttpAbstractions at
        91db78cf926939821bc96e8e60616cf5dde0b489
        <br />
        <br />
        https://asp.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/aspnet/AspNetCore/2.0.0/LICENSE.txt
        <br />
        <br />
        <br />
        License notice for Microsoft.NET.StringTools (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/msbuild at 4242f381a90f77f483b123819759db1ff8eddf67
        <br />
        <br />
        http://go.microsoft.com/fwlink/?LinkId=624683
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Platforms (v3.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.NETCore.Targets (v1.1.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.Registry (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Microsoft.Win32.SystemEvents (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for NETStandard.Library (v1.6.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Newtonsoft.Json (v13.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JamesNK/Newtonsoft.Json at
        ae9fe44e1323e91bcbd185ca1a14099fba7c021f
        <br />
        <br />
        https://www.newtonsoft.com/json
        <br />
        <br />
        Copyright © James Newton-King 2008
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for Newtonsoft.Json.Bson (v1.0.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/JamesNK/Newtonsoft.Json.Bson
        <br />
        <br />
        http://www.newtonsoft.com/json
        <br />
        <br />
        Copyright © James Newton-King 2017
        <br />
        <br />
        License available at
        https://raw.github.com/JamesNK/Newtonsoft.Json.Bson/master/LICENSE.md
        <br />
        <br />
        <br />
        License notice for NReco.Csv (v1.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/nreco/csv
        <br />
        <br />
        Copyright (c) 2017-2018 Vitalii Fedorchenko
        <br />
        <br />
        License available at
        https://raw.githubusercontent.com/nreco/csv/master/LICENSE
        <br />
        <br />
        <br />
        License notice for
        runtime.debian.8-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.23-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.fedora.24-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.IO.Compression (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Net.Http (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.Apple (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.13.2-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.opensuse.42.1-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.Apple
        (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.osx.10.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.rhel.7-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.14.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.04-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for
        runtime.ubuntu.16.10-x64.runtime.native.System.Security.Cryptography.OpenSsl
        (v4.3.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for SQLitePCLRaw.bundle_e_sqlite3 (v2.1.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/ericsink/SQLitePCL.raw
        <br />
        <br />
        Copyright 2014-2022 SourceGear, LLC
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for SQLitePCLRaw.core (v2.1.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/ericsink/SQLitePCL.raw
        <br />
        <br />
        Copyright 2014-2022 SourceGear, LLC
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for SQLitePCLRaw.lib.e_sqlite3 (v2.1.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/ericsink/SQLitePCL.raw
        <br />
        <br />
        Copyright 2014-2022 SourceGear, LLC
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for SQLitePCLRaw.provider.e_sqlite3 (v2.1.2)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/ericsink/SQLitePCL.raw
        <br />
        <br />
        Copyright 2014-2022 SourceGear, LLC
        <br />
        <br />
        Licensed under Apache-2.0
        <br />
        <br />
        Available at https://licenses.nuget.org/Apache-2.0
        <br />
        <br />
        <br />
        License notice for System.AppContext (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Buffers (v4.5.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Collections (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Collections.Concurrent (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ComponentModel (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ComponentModel.Annotations (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Configuration.ConfigurationManager (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Console (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Debug (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.DiagnosticSource (v4.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.PerformanceCounter (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.StackTrace (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Tools (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.TraceSource (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Diagnostics.Tracing (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Drawing.Common (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Globalization (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Calendars (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Globalization.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.Compression (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.Compression.ZipFile (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem.AccessControl (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.IO.FileSystem.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Linq (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Linq.Expressions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Memory (v4.5.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Net.Http (v4.3.4)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.NameResolution (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Net.Sockets (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.ObjectModel (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Private.DataContractSerialization (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit.ILGeneration (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Emit.Lightweight (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.Metadata (v1.6.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Reflection.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Reflection.TypeExtensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Resources.ResourceManager (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.CompilerServices.Unsafe (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Runtime.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Handles (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.InteropServices (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.InteropServices.RuntimeInformation (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Numerics (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Serialization.Json (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Runtime.Serialization.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.AccessControl (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Algorithms (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Cng (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Csp (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.OpenSsl (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Pkcs (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Primitives (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.ProtectedData (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.X509Certificates (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Security.Cryptography.Xml (v4.5.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Security.Permissions (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Security.Principal.Windows (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding.CodePages (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Encoding.Extensions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Text.Encodings.Web (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.Json (v6.0.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/runtime at 4822e3c3aa77eb82b2fb33c9321f923cf11ddde6
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Text.RegularExpressions (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Tasks (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Tasks.Extensions (v4.5.1)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at https://github.com/dotnet/corefx/blob/master/LICENSE.TXT
        <br />
        <br />
        <br />
        License notice for System.Threading.Thread (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Threading.Timer (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Windows.Extensions (v4.7.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/dotnet/corefx
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        Licensed under MIT
        <br />
        <br />
        Available at https://licenses.nuget.org/MIT
        <br />
        <br />
        <br />
        License notice for System.Xml.ReaderWriter (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XDocument (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XmlDocument (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for System.Xml.XmlSerializer (v4.3.0)
        <br />
        ------------------------------------
        <br />
        <br />
        https://dot.net/
        <br />
        <br />
        Copyright © Microsoft Corporation. All rights reserved.
        <br />
        <br />
        License available at http://go.microsoft.com/fwlink/?LinkId=329770
        <br />
        <br />
        <br />
        License notice for Unity (v5.11.10)
        <br />
        ------------------------------------
        <br />
        <br />
        https://github.com/unitycontainer/unity
        <br />
        <br />
        Copyright © .NET Foundation and Contributors. All Rights Reserved
        <br />
        <br />
        License available at https://github.com/unitycontainer/unity/blob/v5.x/LICENSE
        <br />
        <br />
        <table className="thirdPartyTable">
            <thead>
            <tr>
                <th className="string">name</th>
                <th className="string">material / not material</th>
                <th className="string">license type</th>
                <th className="string">author</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="string">@fontsource/comfortaa</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Lotus declininglotus@gmail.com</td>
            </tr>
            <tr>
                <td className="string">@fontsource/roboto</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Lotus declininglotus@gmail.com</td>
            </tr>
            <tr>
                <td className="string">@hookform/resolvers</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">bluebill1049 bluebill1049@hotmail.com</td>
            </tr>
            <tr>
                <td className="string">@microsoft/applicationinsights-react-js</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Microsoft Application Insights Team</td>
            </tr>
            <tr>
                <td className="string">@microsoft/applicationinsights-web</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Microsoft Application Insights Team</td>
            </tr>
            <tr>
                <td className="string">@mui/icons-material</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">MUI Team</td>
            </tr>
            <tr>
                <td className="string">@mui/lab</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">MUI Team</td>
            </tr>
            <tr>
                <td className="string">@mui/x-date-pickers</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">MUI Team</td>
            </tr>
            <tr>
                <td className="string">@react-three/drei</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">@react-three/fiber</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Paul Henschel (https://github.com/drcmda)</td>
            </tr>
            <tr>
                <td className="string">@reactour/tour</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Lionel Tzatzkin</td>
            </tr>
            <tr>
                <td className="string">@reduxjs/toolkit</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Mark Erikson mark@isquaredsoftware.com</td>
            </tr>
            <tr>
                <td className="string">@testing-library/jest-dom</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Ernesto Garcia gnapse@gmail.com (http://gnapse.github.io)
                </td>
            </tr>
            <tr>
                <td className="string">@testing-library/react</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Kent C. Dodds me@kentcdodds.com (https://kentcdodds.com)
                </td>
            </tr>
            <tr>
                <td className="string">@testing-library/react-hooks</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Michael Peyper mpeyper7@gmail.com</td>
            </tr>
            <tr>
                <td className="string">@types/jest</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">@types/papaparse</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">@types/react</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">@types/react-dom</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">@types/react-image-gallery</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">@types/three</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">axios</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Matt Zabriskie</td>
            </tr>
            <tr>
                <td className="string">base-64</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Mathias Bynens https://mathiasbynens.be/</td>
            </tr>
            <tr>
                <td className="string">body-scroll-lock</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Will Po</td>
            </tr>
            <tr>
                <td className="string">browser-detect</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">PIGNOSE kennethan@nhpcw.com</td>
            </tr>
            <tr>
                <td className="string">cross-domain-storage</td>
                <td className="string">material</td>
                <td className="string">ISC</td>
                <td className="string">Matt Larner matt.larner.dev@gmail.com</td>
            </tr>
            <tr>
                <td className="string">customize-cra</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Adam Rackis</td>
            </tr>
            <tr>
                <td className="string">date-fns</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">dayjs</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">iamkun</td>
            </tr>
            <tr>
                <td className="string">file-select-dialog</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                TomokiMiyauci development.operation.6.6.6@gmail.com
                </td>
            </tr>
            <tr>
                <td className="string">fscreen</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Rafael Pedicini rafael@rafgraph.dev</td>
            </tr>
            <tr>
                <td className="string">html2canvas</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Niklas von Hertzen niklasvh@gmail.com https://hertzen.com
                </td>
            </tr>
            <tr>
                <td className="string">https-browserify</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                James Halliday mail@substack.net http://substack.net
                </td>
            </tr>
            <tr>
                <td className="string">immer</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Michel Weststrate</td>
            </tr>
            <tr>
                <td className="string">material-ui-popup-state</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Andy Edwards</td>
            </tr>
            <tr>
                <td className="string">messagepack</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">mprot</td>
            </tr>
            <tr>
                <td className="string">moment</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Iskren Ivov Chernev iskren.chernev@gmail.com
                (https://github.com/ichernev)
                </td>
            </tr>
            <tr>
                <td className="string">papaparse</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Matthew Holt https://twitter.com/mholt6</td>
            </tr>
            <tr>
                <td className="string">react</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">react-beautiful-dnd</td>
                <td className="string">material</td>
                <td className="string">Apache-2.0</td>
                <td className="string">Alex Reardon areardon@atlassian.com</td>
            </tr>
            <tr>
                <td className="string">react-color</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">case case@casesandberg.com</td>
            </tr>
            <tr>
                <td className="string">react-cookie-consent</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Rick van Lieshout info@rickvanlieshout.com</td>
            </tr>
            <tr>
                <td className="string">react-copy-to-clipboard</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Nik Butenko nik@butenko.me</td>
            </tr>
            <tr>
                <td className="string">react-dom</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">react-dropzone</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Param Aggarwal</td>
            </tr>
            <tr>
                <td className="string">react-helmet</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">NFL engineers@nfl.com</td>
            </tr>
            <tr>
                <td className="string">react-hook-form</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">bluebill1049@hotmail.com</td>
            </tr>
            <tr>
                <td className="string">react-icons</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Goran Gajic</td>
            </tr>
            <tr>
                <td className="string">react-image-gallery</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Xiao Lin</td>
            </tr>
            <tr>
                <td className="string">react-joyride</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Gil Barbara gilbarbara@gmail.com</td>
            </tr>
            <tr>
                <td className="string">react-json-tree</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Shu Uesugi shu@chibicode.com (http://github.com/chibicode)
                </td>
            </tr>
            <tr>
                <td className="string">react-json-view</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Mac Gainor</td>
            </tr>
            <tr>
                <td className="string">react-keyboard-event-handler</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">David Lin</td>
            </tr>
            <tr>
                <td className="string">react-lottie</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">react-redux</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Dan Abramov dan.abramov@me.com (https://github.com/gaearon)
                </td>
            </tr>
            <tr>
                <td className="string">react-router-dom</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Remix Software hello@remix.run</td>
            </tr>
            <tr>
                <td className="string">react-router-hash-link</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Rafael Pedicini rafael@rafgraph.dev</td>
            </tr>
            <tr>
                <td className="string">react-scripts</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">react-spinners</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">David Hu (https://www.davidhu.io)</td>
            </tr>
            <tr>
                <td className="string">react-spreadsheet</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Iddan Aaronsohn mail@aniddan.com (https://aniddan.com)
                </td>
            </tr>
            <tr>
                <td className="string">react-spreadsheet-grid</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Denis Raslov denis.raslov@yandex.ru</td>
            </tr>
            <tr>
                <td className="string">react-user-guide</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">sandeshshrestha</td>
            </tr>
            <tr>
                <td className="string">react-uuid</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Rick Brown ricky.brown.00@gmail.com
                (https://github.com/RickBr0wn/minimal-react-boilerplate)
                </td>
            </tr>
            <tr>
                <td className="string">reactour</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">
                Lionel T elrumordelaluz@hotmail.com (https://elrumordelaluz.com/)
                </td>
            </tr>
            <tr>
                <td className="string">redux-persist</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string" />
            </tr>
            <tr>
                <td className="string">scheduler</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">scichart</td>
                <td className="string">material</td>
                <td className="string">ISC</td>
                <td className="string">SciChart Ltd</td>
            </tr>
            <tr>
                <td className="string">stream-http</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">John Hiesey</td>
            </tr>
            <tr>
                <td className="string">styled-components</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Glen Maddern</td>
            </tr>
            <tr>
                <td className="string">three</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">mrdoob</td>
            </tr>
            <tr>
                <td className="string">typeface-fira-sans</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Kyle Mathews mathews.kyle@gmail.com</td>
            </tr>
            <tr>
                <td className="string">typescript</td>
                <td className="string">material</td>
                <td className="string">Apache-2.0</td>
                <td className="string">Microsoft Corp.</td>
            </tr>
            <tr>
                <td className="string">url</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">n/a</td>
            </tr>
            <tr>
                <td className="string">use-query-params</td>
                <td className="string">material</td>
                <td className="string">ISC</td>
                <td className="string">Peter Beshai peter.beshai@gmail.com</td>
            </tr>
            <tr>
                <td className="string">use-react-screenshot</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">vre2h</td>
            </tr>
            <tr>
                <td className="string">web-vitals</td>
                <td className="string">material</td>
                <td className="string">Apache-2.0</td>
                <td className="string">
                Philip Walton philip@philipwalton.com http://philipwalton.com
                </td>
            </tr>
            <tr>
                <td className="string">zod</td>
                <td className="string">material</td>
                <td className="string">MIT</td>
                <td className="string">Colin McDonnell colin@colinhacks.com</td>
            </tr>
            </tbody>
        </table>
        </>
    ) 
}